export const setKeys = (keys) => {
    return {
        type: 'SETTINGS_SET_KEYS',
        payload: {
            keys,
        },
    };
};
